import { Analytics } from "@/shared/utils/analytics/analytics";

/* eslint-disable @typescript-eslint/prefer-as-const */
export class AnalyticsMultiwagersBet {
    gameCode: string;
    multibetName: string;
    multibetPosition: number;
    multibetID: number;
    value: number;
    private readonly bettingSystem = "multibets";
    private readonly bettingMode = "randomTips";
    private verticalCode = Analytics.vertical;

    constructor(gameCode: string, multibetName: string, multibetPosition: number, multibetID: number, value: number) {
        this.gameCode = Analytics.getLotteryCode(gameCode);
        this.multibetName = multibetName;
        this.multibetPosition = multibetPosition;
        this.multibetID = multibetID;
        this.value = value;
    }
}
